// types
import { ParsedUrlQuery } from "querystring";

export const parseCampaign = (campaign: string, referrer: string) => {
  const raw = decodeURIComponent(campaign);
  const qs = raw.split("?")?.[1] || "";
  const utms = qs.split("&") || [];
  const utm_source =
    utms.find((f) => f.includes("utm_source="))?.replace("utm_source=", "") ||
    "";
  const utm_medium =
    utms.find((f) => f.includes("utm_medium="))?.replace("utm_medium=", "") ||
    "";
  const utm_campaign =
    utms
      .find((f) => f.includes("utm_campaign="))
      ?.replace("utm_campaign=", "") || "";
  const utm_content =
    utms.find((f) => f.includes("utm_content="))?.replace("utm_content=", "") ||
    "";
  const utm_term =
    utms.find((f) => f.includes("utm_term="))?.replace("utm_term=", "") || "";

  return {
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    utm_term,
    gtm_referrer: referrer,
    gtm_campaign_url: campaign,
  };
};

export const getTrackers = (cookies: any, query: ParsedUrlQuery) => {
  const {
    utm_source = "",
    utm_medium = "",
    utm_campaign = "",
    utm_content = "",
    utm_term = "",
    type = "",
    payor = "",
    _ef_transaction_id = "",
    flow_type = "",
  } = query;

  const cookie = parseCampaign(
    cookies[0]?.__gtm_campaign_url,
    cookies[0]?.__gtm_referrer,
  );

  return {
    Source:
      utm_source !== ""
        ? utm_source
        : cookie.utm_source
          ? cookie.utm_source
          : cookies[0]?.og_referrer_domain,
    utm_source: utm_source !== "" ? (utm_source as string) : cookie.utm_source,
    utm_medium: utm_medium !== "" ? (utm_medium as string) : cookie.utm_medium,
    utm_campaign:
      utm_campaign !== "" ? (utm_campaign as string) : cookie.utm_campaign,
    utm_content:
      utm_content !== "" ? (utm_content as string) : cookie.utm_content,
    utm_term: utm_term !== "" ? (utm_term as string) : cookie.utm_term,
    gtm_referrer: cookie.gtm_referrer || "",
    gtm_campaign_url: cookie.gtm_campaign_url || "",
    entryPoint: window?.location?.href,
    og_referrer: cookies[0]?.og_referrer_domain,
    type: type,
    insurance: payor.toString(),
    _ef_transaction_id: _ef_transaction_id.toString(),
    flow_type: flow_type.toString(),
  };
};
